import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Process } from '../../shared';
import { PostingType } from '../../lookups';
import { ServiceItem } from '../store/service-item.model';
import { LoggingService } from '../../shared/services/logging/logging.service';
import { SelectItem } from '../../shared/efaact-primeng.module';
import { ResponseStatus, IStatusMessage } from '../../shared';
import { ReplaySubject } from 'rxjs';
import { IShowErrors } from '../../shared/errors-sidenav';

@Component({
    selector: 'ef-posting-item',
    templateUrl: './posting-item.component.html',
    styleUrls: ['./posting-item.component.scss'],
    standalone: false
})
export class PostingItemComponent implements OnInit {
    @Input() process: Process;
    @Input() loading = false;
    @Input() items: PostingType[];
    @Input() serviceItems: ServiceItem[];
    @Output() SavePostingType = new ReplaySubject<PostingType>(1);
    @Output() public ShowError = new EventEmitter<IShowErrors>();
    public get SelectServiceItems(): SelectItem[] {
        return this.serviceItems.map(x => ({
            label: x.ServiceItemDescription,
            value: x.SIListID
        }));
    }
    private _selectedError: IStatusMessage;
    @Input() public set selectedError(value: IStatusMessage) {
        if (!value) {
            return;
        }
        if (this._selectedError && this._selectedError.MsgEntityID) {
            const oldRow = document.getElementById(
                `row-${this._selectedError.MsgEntityID.toString()}`
            );
            if (oldRow) {
                oldRow.classList.remove('highlight');
                oldRow.classList.remove('highlight-warning');
                oldRow.classList.remove('highlight-danger');
            }
        }
        this._selectedError = value;
        if (!(value && value.MsgEntityID)) {
            return;
        }
        const row = document.getElementById(
            `row-${value.MsgEntityID.toString()}`
        );
        this.log.verbose({
            type: 'PostingItemComponent:selectedError',
            value,
            row
        });
        if (!row) {
            return;
        }
        row.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'nearest'
        });
        row.classList.add('highlight');
        if (value.StatusCode === ResponseStatus.Warning) {
            row.classList.add('highlight-warning');
        }
        if (value.StatusCode === ResponseStatus.Failed) {
            row.classList.add('highlight-danger');
        }
    }
    public get selectedError(): IStatusMessage {
        return this._selectedError;
    }

    cloned: { [i: number]: PostingType } = {};

    public editing: PostingType = {} as PostingType;
    constructor(private log: LoggingService) {}

    ngOnInit() {}
    onEditInit($event: { data: PostingType }) {
        const item = this.items.find(
            x => x.PostingType === $event.data.PostingType
        );
        this.log.verbose({
            type: 'PostingItemComponent:onEditInit',
            $event,
            editing: this.editing,
            item
        });
        this.editing = { ...$event.data };
    }
    onEditComplete($event: { data: Partial<PostingType> }) {
        this.log.verbose({
            type: 'PostingItemComponent:onEditComplete',
            $event
        });
        const item = this.items.find(x => x.ListID === $event.data.ListID);

        if (item === this.editing) {
            // this.editing = null;
            this.log.verbose({
                type: 'PostingItemComponent:onEditComplete',
                value: 'no change'
            });
            return;
        }
        this.SavePostingType.next(item);
        item.Description = this.serviceItems.findIndex(
            x => x.SIListID === item.ListID
        )
            ? this.serviceItems.find(x => x.SIListID === item.ListID)
                  .ServiceItemDescription
            : '';
        this.log.verbose({
            type: 'PostingItemComponent:onEditComplete',
            $event,
            item,
            editing: this.editing
        });
    }
    onRowEditInit(item: PostingType) {
        this.log.verbose({
            type: 'PostingItemComponent:onRowEditInit',
            r: item,
            clonedItems: this.cloned
        });
        this.cloned[item.PostingType] = { ...item };
        this.editing = item;
    }
    onRowEditSave(item: PostingType) {
        this.log.verbose({
            type: 'PostingItemComponent:onRowEditSave',
            item,
            clonedItems: this.cloned
        });
        item.Status = {
            StatusCode: ResponseStatus.Loading,
            Message: 'Saving'
        };
        this.SavePostingType.next(item);
        item.Description = this.serviceItems.findIndex(
            x => x.SIListID === item.ListID
        )
            ? this.serviceItems.find(x => x.SIListID === item.ListID)
                  .ServiceItemDescription
            : '';
        delete this.cloned[item.PostingType];
        delete this.editing;
    }
    onRowEditCancel(item: PostingType) {
        this.log.verbose({
            type: 'PostingItemComponent:onRowEditCancel',
            item,
            clonedItems: this.cloned
        });

        const index = this.items.findIndex(
            x => x.PostingType === item.PostingType
        );
        if (index >= 0) {
            this.items.splice(index, 1, this.cloned[item.PostingType]);
        }
        this.items = [...this.items];

        delete this.cloned[item.PostingType];
        delete this.editing;
    }

    onStatusClick(item: PostingType) {
        this.ShowError.next({
            open: true,
            MsgEntityID: item.PostingType.toString()
        });
    }

    getServiceItemsForPosting(postingType: string) {
        return this.serviceItems
            .filter(x => x.Postingtype === postingType)
            .map(x => ({
                label: x.ServiceItemDescription,
                value: x.SIListID
            }));
    }
}
